import { render, staticRenderFns } from "./fivefloor.vue?vue&type=template&id=31d3fa10&scoped=true&"
import script from "./fivefloor.vue?vue&type=script&lang=js&"
export * from "./fivefloor.vue?vue&type=script&lang=js&"
import style0 from "./fivefloor.vue?vue&type=style&index=0&id=31d3fa10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d3fa10",
  null
  
)

export default component.exports